import API from "../../../../app/api";

/* ------------------ Get Orders List ------------------ */
export const getOrders = async (filters = {}) => {
    const cleanedFilters = Object.fromEntries(
        Object.entries(filters).filter(
            ([_, value]) =>
                value !== undefined && value !== null && value !== ""
        )
    );

    const queryParams = new URLSearchParams(cleanedFilters).toString();
    const url = queryParams ? `/orders?${queryParams}` : "/orders";

    const response = await API.get(url);
    return response?.data?.data;
};

/* ------------------ Get Single Order ------------------ */
export const getOrderById = async (orderNo) => {
    const response = await API.get(`/orders/${orderNo}`);
    return response?.data?.data;
};
